<template>
  <div class="message">
    <span class="bubble" v-html="message"></span>
  </div>
</template>

<script>
export default {
  name: 'chat-message',

  props: {
    message: String
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'
@import '../../stylesheets/base/theme'

.message
  margin: 0 auto $gap-small
  display: block

  .bubble
    color: #fff
    letter-spacing: 1px
    display: inline-block
    padding: 5px 10px
    border-radius: 10px
    font-size: 16px
    max-width: 75%

    &:first-letter
      text-transform: uppercase

  &:nth-child(even)
    text-align: right

    .bubble
      @include themify($themes)
        background: themed('color-primary')

  &:nth-child(odd)
    .bubble
      @include themify($themes)
        background: themed('color-secondary')
</style>
